export function AssetLibEntryUrl(props: { data : any }) {
  return (
    <a href={props.data.file} target='_blank' className='gallery_product col-lg-2 col-md-2 col-sm-3 col-xs-6' rel="noreferrer" >
      <img className='img-responsive box-wh' src="/assets/img/tutorial.png" alt={props.data.name} />
      <p className='text-center'>{props.data.name}</p>
    </a>
    );
}
